<section *ngIf="this.lastSegment == 'search'" class="search-section">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-xxl-6 col-xl-8 mx-auto">
                <div class="title d-block text-center">
                    <h2>Search for products</h2>
                    <span class="title-leaf">
            <svg class="icon-width">
              <use xlink:href="../assets/svg/leaf.svg#leaf"></use>
            </svg>
          </span>
                </div>

                <div class="search-box">
                    <div class="input-group">
                        <input (keyup)="changeSearch($event)" type="text" class="form-control" placeholder="I'm searching for...">
                        <button (click)="searchPage()" class="btn theme-bg-color text-white m-0" type="button" id="button-addon1">Search</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Product Section Start -->
<section class="pb-md-5 product-section">

    <!-- <div class="container-fluid-lg loader" *ngIf="isLoading">
        <div class="row ">
            <div class="col-12 d-flex justify-content-center ">
                <div class="spinner-border text-success" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div> -->
    <div class="container-fluid-lg" *ngIf="!isLoading && DataList.length; else emptyData">
        <div class="title ">
            <h2>Search Products list</h2>
        </div>
        <div class="row">
            <div *ngFor="let product of DataList" class="product-card" class="col-lg-2 col-md-4 col-sm-6 pb-10">
                <div class="product-box-4">
                    <div class="product-image">
                        <div class="label-flex">
                            <div *ngIf="product.popular_status == 1" class="discount">
                                <label>Most Popular</label>
                            </div>
                            <button *ngIf="product?.wishlist && tokens; else addWishList " class="btn p-0 wishlist btn-wishlist notifi-wishlist" (click)="removeToWishlist(product.id)">
                <!-- <i class="iconly-Heart icli"
                  matTooltip="Click me to for view wishlist!"></i> -->
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="green"  matTooltip="Remove for wishlist!">
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                </svg>
              </button>

                            <ng-template #addWishList>
                                <button class="btn p-0 wishlist btn-wishlist notifi-wishlist">
                  <i (click)="addToWishlist(product.id)"
                    class="iconly-Heart icli"></i>
                </button>
                            </ng-template>
                        </div>

                        <ng-container>
                            <!-- First condition -->
                            <ng-container *ngIf="product.product_type == 0; else checkVariation">
                                <a class="pointer" (click)="navigateToProductDetail(product,product.id, product.product_slug,'0')">
                                    <img [src]="imageBaseUrl + product.product_thumbnail ? imageBaseUrl + product.product_thumbnail : domiImageBaseUrl" class="img-fluid" alt />

                                </a>
                            </ng-container>

                            <!-- Second condition -->
                            <ng-template #checkVariation>
                                <ng-container *ngIf="product.variations?.image?.image_path; else defaultThumbnail">
                                    <a class="pointer" (click)="navigateToProductDetail(product,product.id, product.product_slug,product.variations.variations_code)">
                                        <img [src]="imageBaseUrl + product.variations.image.image_path ? imageBaseUrl + product.variations.image.image_path : domiImageBaseUrl" class="img-fluid" alt />
                                    </a>
                                </ng-container>
                            </ng-template>

                            <!-- Default condition -->
                            <ng-template #defaultThumbnail>

                                <a class="pointer" *ngIf="product.variations.variations_code; else defaultvariations" (click)="navigateToProductDetail(product,product.id, product.product_slug,product.variations.variations_code)">
                                    <img [src]="imageBaseUrl + product.product_thumbnail ? imageBaseUrl + product.product_thumbnail : domiImageBaseUrl" class="img-fluid" alt />
                                </a>

                                <ng-template #defaultvariations>

                                    <a class="pointer" (click)="navigateToProductDetail(product,product.id, product.product_slug,'0')">
                                        <img [src]="imageBaseUrl + product.product_thumbnail ? imageBaseUrl + product.product_thumbnail : domiImageBaseUrl" class="img-fluid" alt />
                                    </a>

                                </ng-template>
                            </ng-template>
                        </ng-container>
                    </div>

                    <div class="product-detail">
                        <a>
                            <h5 class="name">{{ product.product_name || "" }}</h5>
                        </a>
                        <div>

                            <ng-container *ngIf="product.product_type == 0 ; else notVariation">
                                <h5 class="price theme-color">
                                    ₹{{ product.discount_price || product.selling_price}}
                                </h5>
                            </ng-container>
                            <ng-template #notVariation>
                                <h5 class="price theme-color">
                                    ₹{{ product.variations.discount_price|| product.variations.variations_price}}
                                </h5>
                            </ng-template>

                        </div>

                        <!-- Show 'Out of Stock' if product_stock is 0 or variations.stock is unavailable -->
                        <div class="price-qty" *ngIf="product?.product_stock == 0 || (product.variations?.stock == '0'); else inStock">
                            <p>Out of Stock</p>
                        </div>

                        <!-- In-Stock Template -->
                        <ng-template #inStock>
                            <!-- Show 'Go to Cart' if product is already in the cart -->
                            <span *ngIf="product?.cart && tokens; else addToCart">
                <button class="buy-button buy-button-2 btn svr_GotoCart">

                  <i class="fa fa-eye icli text-white m-0"
                    [routerLink]="['/users/account/cart']"
                    matTooltip="Click me to for view cart!"></i>

                </button>
              </span>

                            <!-- Template for "Add to Cart" -->
                            <ng-template #addToCart>

                                <button *ngIf="product.product_type == 1 ;else variantCart" (click)="openModal(product)" class="buy-button buy-button-2 btn">
                  <i class="iconly-Buy icli text-white m-0"></i>
                </button>

                                <ng-template #variantCart>
                                    <button (click)="addToCartData(product.id, 1, product.variations? product.variations.discount_price || product.variations.variations_price : product.discount_price?  product.discount_price:product.selling_price, product.product_type, product.variations ? product.variations.id : '')"
                                        class="buy-button buy-button-2 btn">
                    <i class="iconly-Buy icli text-white m-0"></i>
                  </button>
                                </ng-template>

                                <!-- Button for Variant Products -->

                            </ng-template>
                        </ng-template>

                    </div>
                </div>
            </div>
            <div id="myModal" class="modal" [ngClass]="{'show': isModalOpen}" (click)="closeModal($event)">
                <!-- <div id="myModal" class="modal" [class.show]="isModalOpen" [style.display]="isModalOpen ? 'block' : 'none'" (click)="closeModal($event)"> -->


                <!-- Modal content -->
                <div class="modal-content" (click)="stopPropagation($event)">
                    <div class="modal-header">
                        <h2>Product Details</h2>
                        <span class="close" (click)="closeModal($event)">&times;</span>

                    </div>
                    <div class="modal-body">
                        <div class="product-section">
                            <div class="right-box-contain">
                                <div class="note-box product-package">

                                    <div class="product-package-img">
                                        <img [src]="imageBaseUrl + firstVariationImagePath ? imageBaseUrl + firstVariationImagePath : domiImageBaseUrl" class="img-fluid" alt />
                                    </div>
                                    <div class="product-package-info">
                                        <div class="price-rating">
                                            <div class="theme-color price">
                                                <h3>₹{{ price ||'' }}</h3>
                                            </div>
                                        </div>
                                        <div class="product-package" *ngFor="let attributeData of attrVariationDataList?.attributeTermData">
                                            <div class="product-title">
                                                <h4>{{ attributeData.name }}</h4>
                                            </div>
                                            <ul class="select-package">
                                                <li *ngFor="let termData of attributeData.terms">
                                                    <a href="javascript:void(0)" [ngClass]="{ 'active': activeTerms[attributeData.id] === termData.id }" (click)="setActiveTerm(attributeData.id, termData.id)">
                            {{ termData.name }}
                          </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div class="product-qty-box">
                                            <div class="cart_qty qty-box product-qty">
                                                <div class="input-group">
                                                    <button type="button" (click)="plusMinusQuantity('minus')" class="qty-left-minus" data-type="minus" data-field>
                            <i class="fa fa-minus"></i>
                          </button>
                                                    <input class="form-control input-number qty-input" type="text" name="quantity" value="{{ quantity }}">
                                                    <button type="button" (click)="plusMinusQuantity('plus')" class="qty-right-plus" data-type="plus" data-field>
                            <i class="fa fa-plus"></i>
                          </button>
                                                </div>
                                            </div>
                                            <button (click)="addToCartData(product.id, quantity,price, product.product_type, variant_id ? variant_id : '')" class="btn btn-md bg-dark cart-button text-white w-100">
                        <span *ngIf="!isCartLoading">Add To Cart</span>
                        <span *ngIf="isCartLoading"
                          class="spinner-border spinner-border-sm spinner-grow flex-shrink-0"
                          role="status" aria-hidden="true">
                          <p> Loading..</p></span>

                      </button>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
        <nav class="custom-pagination" *ngIf="this.lastSegment != undefined && this.lastSegment != 's' && this.lastSegment != 'search'">
            <ul class="pagination justify-content-center">
                <!-- Previous Button -->
                <li class="page-item" [class.disabled]="pagination.page === 0">
                    <a class="page-link" href="javascript:void(0)" (click)="onPageChange(pagination.page - 1)">
                        <i class="fa-solid fa-angles-left"></i>
                    </a>
                </li>

                <!-- Page Numbers -->
                <li class="page-item" *ngFor="let page of [].constructor(totalPages); let i = index" [class.active]="pagination.page === i">
                    <a class="page-link" href="javascript:void(0)" (click)="onPageChange(i)">
            {{ i + 1 }}
          </a>
                </li>

                <!-- Next Button -->
                <li class="page-item" [class.disabled]="pagination.page === totalPages - 1">
                    <a class="page-link" href="javascript:void(0)" (click)="onPageChange(pagination.page + 1)">
                        <i class="fa-solid fa-angles-right"></i>
                    </a>
                </li>
            </ul>
        </nav>
        <div class="col-12 d-flex justify-content-center" *ngIf="this.lastSegment == undefined">
            <a [routerLink]="['/product']" routerLinkActive="active-link-class" class="btn btn-md text-white theme-bg-color mt-4 mx-auto">View All</a>
        </div>
    </div>
    <ng-template #emptyData>
        <div class="container-fluid-lg" *ngIf="!isLoading">
            <div class=" title ">
                <h2>Products</h2>
            </div>
            <div class="row ">
                <div class="col-12 d-flex justify-content-center ">
                    <div class="svr_nodata ">
                        <h4>No data available!</h4>
                        <p>There is no data to show you right now</p>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</section>
<!-- Product Section End -->
